(function () {
var settingsElement = document.getElementById('oke-reviews-settings');
var config = JSON.parse(settingsElement.innerText);
config.reviewCollapsedMode = 'text-and-attributes';
settingsElement.innerText = JSON.stringify(config);
})();

window.okeReviewsWidgetOnInit = function () {
    setupAggregate();
  
    const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewMain) {
        const callback = function (mutationList) {
            for (const mutation of mutationList) {
                mutation.addedNodes.forEach(n => setupMinimalReviews(n));
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(reviewMain, { childList: true });
        // Run callback for the first time
        const reviews = document.querySelectorAll('.okeReviews-reviews-review');
        reviews.forEach(n => setupMinimalReviews(n));
    }
};


function setupAggregate() {
    const filterToggle = document.querySelector('.okeReviews-filterToggle');
    const minimalControls = document.querySelector('.js-okeReviews-writeReview');
    // Move controls to aggregate side inline with the initial elements
    if (filterToggle && minimalControls) {
        filterToggle.insertAdjacentElement('afterend', minimalControls);
    }
}

function setupMinimalReviews(nodeElement) {
    const rangeAttributes = nodeElement.querySelector('.okeReviews-review-attributeRatings');
    const reviewHelpful = nodeElement.querySelector('.js-okeReviews-reviewHelpful');
    // Move range attributes before helpful
    if(rangeAttributes && reviewHelpful) {
        reviewHelpful.insertAdjacentElement('beforebegin', rangeAttributes);
    }

    const reviewControls = nodeElement.querySelector('.okeReviews-review-main-content-controls'); 
    // Move review controls before range attributes
    if(reviewControls && rangeAttributes) {
        rangeAttributes.insertAdjacentElement('beforebegin', reviewControls);
    }

    const seeMoreButton = nodeElement.querySelector('.js-okeReviews-readMore');
    if (seeMoreButton) {
        seeMoreButton.innerText = "See More +";
        seeMoreButton.addEventListener('click', function() {
            seeMoreButton.style.display = "none";
            rangeAttributes.classList.add("expanded");  
        });
    }

    // Move specific attributes outside expandable container
    const yourActivities = nodeElement.querySelector('.okeReviews-sectionedList--yourActivities');
    const productStandouts = nodeElement.querySelector('.okeReviews-sectionedList--productStandouts');
    // Attribute: Your Activities
    if(yourActivities && reviewControls) {
        reviewControls.insertAdjacentElement('beforebegin', yourActivities);
    }
    // Attribute: Product Standouts
    if(productStandouts && reviewControls) {
        productStandouts.parentNode.remove();
        reviewControls.insertAdjacentElement('beforebegin', productStandouts);
    }

    // Create read less button
    var readLess = document.createElement('BUTTON');
    readLess.classList.add("okeReviews-review-main-readLess-button");
    readLess.innerText = "See Less –";
    // Move read less button before end of attribute list
    if(readLess) {
        rangeAttributes.insertAdjacentElement('beforeend', readLess);
        readLess.addEventListener('click', function() {
            seeMoreButton.style.display = "block";
            rangeAttributes.classList.remove("expanded");   
        });
    }
}
